import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class TpPlatformInvoiceBravoJobSearchParams extends SearchParamsBase {
  initialize() {
    // Preset by TpPlatformInvoiceBravoJobsPopup; the backend either takes the per-client
    // scope (BillingPeriod + OfficeId + ClientId from a clicked summary row) or, when
    // those are empty, resolves the invoice-level scope from the frozen Assignment rows.
    // All five are SCOPE, not user filters.
    this.ThirdPartySource = '';
    this.ThirdPartyInvoiceId = '';
    this.BillingPeriod = '';
    this.OfficeId = '';
    this.ClientId = '';
    // User filters. Date bounds are STRINGS, not Date objects — see ProjectSearchParams.
    this.SelectedJobStatuses = [];
    this.UseDateAssignedRange = false;
    this.DateAssignedFrom = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.DateAssignedTo = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.SurveyName = '';
    this.IsOutsourced = '';
  }

  ClearAll() {
    // Deliberately keeps every field — the popup grid is always scoped to one invoice
    // (or one of its client rows).
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedJobStatuses',
      label: 'Job Status',
      className: 'col-6',
      type: InputTypesEnum.TpJobStatusMultiSelect,
    },
    {
      fieldName: 'SurveyName',
      label: 'Survey',
      className: 'col-6',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'IsOutsourced',
      label: 'Outsourced?',
      className: 'col-6',
      type: InputTypesEnum.EmptyYesNoSelect,
      tooltipText: 'Outsourced shops are reported under the office that owns the client.',
    },
    {
      fieldName: 'UseDateAssignedRange',
      label: 'Use Date Assigned Range',
      className: 'col-6',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'DateAssignedFrom',
      label: 'Date Assigned From',
      className: 'col-6',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateAssignedRange,
    },
    {
      fieldName: 'DateAssignedTo',
      label: 'Date Assigned To',
      className: 'col-6',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateAssignedRange,
    },
  ];

  static title = 'Search in Bravo Jobs';
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpPlatformInvoiceBravoJobSearchParams';

  static isThereAnySearchParameter() {
    return false;
  }
}
